import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { PageHeader, Loading, EmptyState, StatusBadge } from "@/components/common";
import { rupiah, formatDate } from "@/lib/format";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Wallet } from "lucide-react";

export default function SupplierPayments() {
  const [rows, setRows] = useState(null);
  useEffect(() => { api.get("/payables/payments").then((r) => setRows(r.data)); }, []);
  return (
    <div>
      <PageHeader title="Pembayaran Supplier" subtitle="Riwayat pembayaran hutang. Jurnal dibuat DRAFT lalu diposting Accounting." testId="payments-header" />
      <div className="rounded-xl border border-slate-200 bg-white shadow-sm overflow-x-auto">
        {!rows ? <Loading /> : rows.length === 0 ? <EmptyState title="Belum ada pembayaran" icon={Wallet} /> : (
          <Table>
            <TableHeader><TableRow>
              <TableHead>No Pembayaran</TableHead><TableHead>Tagihan</TableHead><TableHead>Supplier</TableHead>
              <TableHead>Tanggal</TableHead><TableHead>Metode</TableHead><TableHead>Kas/Bank</TableHead>
              <TableHead className="text-right">Jumlah</TableHead><TableHead>Jurnal</TableHead><TableHead>Status</TableHead>
            </TableRow></TableHeader>
            <TableBody>
              {rows.map((p) => (
                <TableRow key={p.id} data-testid={`payment-row-${p.payment_no}`}>
                  <TableCell className="font-mono text-xs">{p.payment_no}</TableCell>
                  <TableCell className="font-mono text-xs text-slate-500">{p.bill_no}</TableCell>
                  <TableCell>{p.supplier_name}</TableCell>
                  <TableCell className="text-xs text-slate-500">{formatDate(p.payment_date)}</TableCell>
                  <TableCell className="text-xs">{p.payment_method}</TableCell>
                  <TableCell className="text-xs">{p.cash_bank_name}</TableCell>
                  <TableCell className="text-right tabular-nums font-medium">{rupiah(p.amount)}</TableCell>
                  <TableCell><StatusBadge status={p.journal_status} /></TableCell>
                  <TableCell><StatusBadge status={p.status} /></TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        )}
      </div>
    </div>
  );
}
